/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.actor.contentVisibilityDeclaration'

type $nsid = typeof $nsid

export { $nsid }

/** A declaration of an account's preferences for appearing in content discovery surfaces. */
type Main = {
  $type: 'app.bsky.actor.contentVisibilityDeclaration'

  /**
   * Whether the account requests that its posts be hidden from algorithmic recommendations. Consumers must treat a missing record as false.
   */
  hideFromAlgorithmicRecommendations: boolean
}

export type { Main }

/** A declaration of an account's preferences for appearing in content discovery surfaces. */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    hideFromAlgorithmicRecommendations: /*#__PURE__*/ l.boolean(),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
